<template>
  <section class="p-4">
    <h2 class="mb-4 border-b" v-text="$t('common.payment_methods')" />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-if="!loading" id="page-content" v-html="content" />
    <div v-else class="py-5 text-center">
      <i class="fas fa-spinner fa-spin" />
    </div>
  </section>
</template>

<script setup>
const loading = ref(true);
const title = ref(null);
const content = ref(null);

onMounted(() => {
  loadPage();
});

async function loadPage() {
  try {
    const { data } = await useAPI("api/front/pages/payments-method-modal");

    loading.value = false;
    content.value = data.content;
  } catch (error) {
    console.error(error);
  }
}
</script>
